import './Field.css';

const Lupa = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="11" cy="11" r="7" /><path d="m21 21-4.3-4.3" />
  </svg>
);

/** Campo de búsqueda con ícono de lupa. */
export default function SearchInput({ className = '', ...rest }) {
  return (
    <div className="field-search">
      <span className="field-search-icon"><Lupa /></span>
      <input type="search" className={`field-control ${className}`} {...rest} />
    </div>
  );
}